import type { ReactNode } from "react";

interface Props {
  title: string;
  children: ReactNode;
}

export function SidebarSection({ title, children }: Props) {
  return (
    <div className="mb-5">
      <div className="px-3 mb-2 text-[10px] uppercase tracking-wider text-white/40 font-semibold">
        {title}
      </div>
      <div className="flex flex-col gap-0.5">{children}</div>
    </div>
  );
}
